import dynamic from 'next/dynamic'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import AirlineCompatibilityLegacy from './airline-compatibility-legacy'

import type { AirlineCompatibilityProps } from './airline-compatibility.types'

const AirlineCompatibilityDS = dynamic(
  () => import(/* webpackChunkName: "airline-compatibility-ds" */ '@src/components/blocks/airline-compatibility-ds'),
)

const AirlineCompatibility = (props: AirlineCompatibilityProps) => {
  if (shouldUseDesignSystem()) {
    return <AirlineCompatibilityDS {...props} />
  }

  return <AirlineCompatibilityLegacy {...props} />
}

export type { AirlineCompatibilityProps } from './airline-compatibility.types'
export default AirlineCompatibility
